import React from 'react';
import { Button, LinkButton, AnchorButton } from '~button';
import siteLaunchPropTypes from '../../../prop-types/siteLaunchPropTypes';
import CallToActions from './CallToActions';
import CallToAction from './CallToAction';

var CallToActionList = function CallToActionList(_ref) {
  var list = _ref.list;
  return list && /*#__PURE__*/React.createElement(CallToActions, null, list.map(function (item, index) {
    if (item.type === 'link') {
      return /*#__PURE__*/React.createElement(CallToAction, {
        key: index
      }, /*#__PURE__*/React.createElement(LinkButton, {
        to: item.path,
        skin: item.skin,
        icon: item.icon,
        btnType: item.btnType,
        size: item.size
      }, item.label));
    }

    if (item.type === 'anchor') {
      return /*#__PURE__*/React.createElement(CallToAction, {
        key: index
      }, /*#__PURE__*/React.createElement(AnchorButton, {
        path: item.path,
        skin: item.skin,
        icon: item.icon,
        btnType: item.btnType,
        size: item.size
      }, item.label));
    }

    return /*#__PURE__*/React.createElement(CallToAction, {
      key: index
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: item.onClick,
      skin: item.skin,
      icon: item.icon,
      btnType: item.btnType,
      size: item.size
    }, item.label));
  }));
};

CallToActionList.defaultProps = {
  list: null
};
export default CallToActionList;